'use client';
import Typography from '@/components/shared/typography/typography.component';
import { ReactNode, useEffect } from 'react';

const SellFormMobileContetnLayout = ({
    header,
    formContent,
    variantType = 'body1Medium',
}: {
    header: string;
    formContent: ReactNode;
    variantType?: any;
}) => {
    useEffect(() => {
        window.scroll(0, 0);
    }, []);
    return (
        <section
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                padding: '4px 16px 16px',
            }}
        >
            <Typography variant={variantType}>{header}</Typography>
            {formContent && <>{formContent}</>}
        </section>
    );
};
export default SellFormMobileContetnLayout;
